import { useCallback, useEffect, useState } from "react";
import { Certificate } from "../../types/newtypes";
import { useGetCertificatesQuery } from "../../store/api/postgresCertificatesApi";
import { useNavigate } from "react-router-dom";

export const useCertificatesHook = () => {
  const [pollWhilePending, setPollWhilePending] = useState(false);
  const {
    data: certificates = [],
    isLoading: loading,
    error,
  } = useGetCertificatesQuery(undefined, {
    pollingInterval: pollWhilePending ? 10000 : 0,
    skipPollingIfUnfocused: true,
    refetchOnMountOrArgChange: true,
  });

  const navigate = useNavigate();

  useEffect(() => {
    setPollWhilePending(certificates.some((cert) => !cert.download_uri));
  }, [certificates]);

  const navigateHome = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const navigateToCourses = useCallback(() => {
    navigate("/courses");
  }, [navigate]);

  const handleViewCertificate = useCallback(
    (certificate: Certificate) => {
      navigate(`/certificates/${certificate.id}`, { state: { certificate } });
    },
    [navigate],
  );

  const handleDownloadCertificate = useCallback((certificate: Certificate) => {
    try {
      // Use download_uri from API response
      if (certificate?.download_uri) {
        window.open(certificate?.download_uri, "_blank");
      }
    } catch (err) {
      console.error("Error downloading certificate:", err);
    }
  }, []);

  return {
    certificates,
    loading,
    error: error ? "Failed to fetch certificates" : null,
    handleViewCertificate,
    handleDownloadCertificate,
    navigateHome,
    navigateToCourses,
  };
};
